import { getServiceConfig } from "@/config/serviceConfig";
import api from "@/lib/axios";
import { Configuration, ReferenceDocumentControllerApi, type ReferenceDocumentView } from "./generated/casedb";

export async function fetchReferenceDocument(document: ReferenceDocumentView): Promise<Blob> {
  if (document.case_id == null || document.document_id == null) throw new Error("Document identity is missing");
  const config = await getServiceConfig();
  if (!config.caseDb) throw new Error("case-db service URL is not configured");
  const client = new ReferenceDocumentControllerApi(new Configuration(), config.caseDb, api);
  const response = await client.getReferenceDocumentContent(document.case_id, document.document_id, { responseType: "blob" });
  return response.data as unknown as Blob;
}
